module.exports = __webpack_public_path__ + "img/award.98461dc6.png";